import styled from "styled-components";

export const IconWrapper = styled.div`
  margin-right: 4px;
  color: var(--ICON-default);
  font-size: 16px;

`